import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import p from './products';

@Component({
  selector: 'app-tienda',
  templateUrl: './tienda.component.html',
  styleUrls: ['./tienda.component.scss']
})

export class TiendaComponent implements OnInit {

  public listOfProducts = [];
  public products = p;

  router;

  constructor(router: Router) {
    this.router = router;
   }
  ngOnInit() {
    this.listOfProducts = this.products;
  }

  public Search(s) {
   const searches = s.split(' ').filter(String);
   this.listOfProducts = this.all(searches, this.products);
  }

  public all(needles, haystacks) {
    return haystacks.filter((h) => {
      const string = h.id.toString().toLowerCase();
      const a = needles.filter((e) => {
      if (string.indexOf(e) !== -1) { return e; }
    });
      if (a.length === needles.length) { return h; }
  });
}

  public moreInfo(uid: string) {
    this.router.navigate([`ventas/producto/${uid}`]);
  }
}
